import { render, staticRenderFns } from "./FileBankFormAdd.vue?vue&type=template&id=1725bcb2&scoped=true&"
import script from "./FileBankFormAdd.vue?vue&type=script&lang=js&"
export * from "./FileBankFormAdd.vue?vue&type=script&lang=js&"
import style0 from "./FileBankFormAdd.vue?vue&type=style&index=0&id=1725bcb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1725bcb2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VFileInput})
